import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { bandInfo } from '../data/mock';

const Contact = () => {
  const contactInfo = [
    { icon: Phone, label: 'Telefon', value: bandInfo.phone, href: `tel:${bandInfo.phone.replace(/\s/g, '')}` },
    { icon: Mail, label: 'Email', value: bandInfo.email, href: `mailto:${bandInfo.email}` },
    { icon: MapPin, label: 'Lokacija', value: bandInfo.territory, href: null }
  ];

  return (
    <section id="contact" className="py-32 bg-black relative overflow-hidden">
      {/* Decorative Lines */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold-400/20 to-transparent" />

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-gold-400 text-xs font-medium tracking-[0.3em] uppercase mb-6 block">
            Kontaktirajte nas
          </span>
          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-light text-gold-400 mb-6">
            <span className="text-gold-gradient">Kontakt</span>
          </h2>
          <div className="w-16 h-[1px] bg-gold-400 mx-auto mb-8" />
          <p className="text-white/50 max-w-2xl mx-auto text-lg font-light">
            Pozovite nas ili pošaljite email za rezervaciju termina
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid sm:grid-cols-3 gap-6 mb-12">
          {contactInfo.map((item, index) => (
            <div key={index} className="group p-8 border border-white/5 hover:border-gold-400/20 transition-all duration-300 text-center overflow-hidden">
              <div className="w-14 h-14 border border-gold-400/30 flex items-center justify-center mx-auto mb-6 group-hover:border-gold-400/60 transition-colors duration-300">
                <item.icon className="w-6 h-6 text-gold-400" />
              </div>
              <p className="text-white/40 text-xs tracking-[0.2em] uppercase mb-3">{item.label}</p>
              {item.href ? (
                <a href={item.href} className="text-white hover:text-gold-400 transition-colors duration-300 font-light text-sm sm:text-base break-all">
                  {item.value}
                </a>
              ) : (
                <p className="text-white font-light text-sm sm:text-base">{item.value}</p>
              )}
            </div>
          ))}
        </div>

        {/* Main CTA */}
        <div className="text-center">
          <a href={`tel:${bandInfo.phone.replace(/\s/g, '')}`}>
            <button className="btn-gold px-12 py-5 text-lg tracking-[0.15em] uppercase flex items-center justify-center gap-4 mx-auto">
              <Phone className="w-6 h-6" />
              {bandInfo.phone}
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
